var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 24C25.1 24 26.042 23.608 26.826 22.824C27.6087 22.0413 28 21.1 28 20C28 18.9 27.6087 17.958 26.826 17.174C26.042 16.3913 25.1 16 24 16C22.9 16 21.9587 16.3913 21.176 17.174C20.392 17.958 20 18.9 20 20C20 21.1 20.392 22.0413 21.176 22.824C21.9587 23.608 22.9 24 24 24ZM24 44C18.6333 39.4333 14.6253 35.1913 11.976 31.274C9.32533 27.358 8 23.7333 8 20.4C8 15.4 9.60867 11.4167 12.826 8.45C16.042 5.48333 19.7667 4 24 4C28.2333 4 31.958 5.48333 35.174 8.45C38.3913 11.4167 40 15.4 40 20.4C40 23.7333 38.6753 27.358 36.026 31.274C33.3753 35.1913 29.3667 39.4333 24 44Z",
    fill: "#1A1C3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.8a21d11f61147001d2461e3af0ffc98d.svg";
export { ForwardRef as ReactComponent };